import { FC } from "react";
import * as yup from "yup";

import { Calender, XClose } from "untitledui-js-base";
import { Input, Modal } from "shared/components";

import { IconButton, IconButtonSize } from "shared/components";

import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useForm } from "shared/hooks";
import { cx } from "shared/utils";

interface ChangeDayModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  onSubmit: (day: number) => void;
  day: number;
}

const dayFormValidation = yup.object().shape({
  day: yup
    .string()
    .required("Day is required")
    .test("is-between-1-31", "Numbers between 1 and 31", (value) => {
      if (!value) return true;
      const num = Number(value);
      return num >= 1 && num <= 31;
    })
});

export const ChangeDayModal: FC<ChangeDayModalProps> = ({
  isOpen,
  onDismiss,
  onSubmit,
  day: _day
}) => {
  const {
    register,
    onSubmit: formSubmit,
    errors,
    reset
  } = useForm(
    {
      day: _day || 1
    },
    dayFormValidation
  );

  return (
    <Modal
      opened={isOpen}
      onClose={() => {
        reset();
        onDismiss();
      }}
      panelClassName="p-6 w-[320px]"
    >
      <form
        onSubmit={formSubmit({
          onSuccess: (data) => {
            onSubmit(Number(data.day));
            onDismiss();
          }
        })}
      >
        <div className="flex items-center justify-between mb-2">
          <h4 className="text-xl font-bold text-content-1000">
            Change billing day
          </h4>
          <IconButton
            size={IconButtonSize.SM}
            borderLess
            className="translate-x-2"
            Icon={XClose}
            onClick={onDismiss}
          />
        </div>
        <p className="text-sm font-medium text-content-300 mb-6">
          Change the day of the month for billing
        </p>
        <div className="flex gap-4 items-end mb-8">
          <div>
            <Input
              id="day"
              type="number"
              hideOptional
              label="Billing day"
              Icon={Calender}
              maxLength={2}
              {...register("day")}
            />
          </div>
          <div
            className={cx(
              "shrink-0  text-sm font-medium text-content-300",
              errors.day ? "mb-10" : "mb-6"
            )}
          >
            of each month
          </div>
        </div>
        <Button
          size={ButtonSize.SM}
          variant={ButtonVariant.PRIMARY}
          type="submit"
          className="w-full"
        >
          Change
        </Button>
      </form>
    </Modal>
  );
};
